// Copyright (c) 2021 Deere & Company

import './index.scss';

import * as busyCounter from '../../shared/action-creator/busy-counter';
import React, { Component } from 'react';
import { createErrorMessage, createSuccessMessage } from '../../shared/action-creator/alert-messages';
import {
    getATPSetup, getEnvironments, getInventorySources,
    getSuppressSources, getTransactionSources, saveATPSetup
} from './repositories';
import BusyCounterLoadingIndicator from '../../shared/components/busyCounter/busy-counter-loading-indicator';
import LabeledInput from '../../shared/components/labeled-input';
import LabeledReactSelect from '../../shared/components/options-drop-down/labeled-react-select';
import OptionsDropDown from '../../shared/components/options-drop-down';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { showLoadingIndicator } from '../../shared/state/busy-counter';
import { withRouter } from 'react-router-dom';

class ATPSetup extends Component {

    state = {
        environments: [],
        inventorySources: [],
        atpTransactions: [],
        atpSupressFlags: [],
        selectedEnvironment: '',
        selectedInvSource: '',
        results: {},
        isEditing: false,
        selectedSuppressVal: '',
        selectedTransactionVal: ''
    };

    componentDidMount = () => {

        this.props.increaseCounter();
        this.loadTransactionsDropdown();
        this.getsuppressflagDropdown();
        getEnvironments( ).then( response => {

            this.setState( {
                environments: response

            } );
            this.props.decreaseCounter();

        } ).catch( () => {

            this.props.decreaseCounter();

        } );

    }

    handleEnvironmentChange ( val ) {

        this.setState( {
            selectedEnvironment: val

        } );
        this.props.increaseCounter();
        getInventorySources()
            .then( response => {

                const invSrcs = response.map( item => ( {
                    value: item.id.trim(),
                    label: item.value.trim()
                } ) );
                this.setState( {
                    inventorySources: invSrcs

                } );
                this.props.decreaseCounter();

            } )
            .catch( () => {

                this.props.decreaseCounter();

            } );

    }

    handleinvSrcChange ( val ) {

        this.setState( {
            selectedInvSource: val

        }, () => {

            this.refresh();

        } );

    }

    handleTransactionChange ( val ) {

        this.setState( {
            selectedTransactionVal: val
        } );

    }

    handleSuppressChange ( val ) {

        this.setState( {
            selectedSuppressVal: val
        } );

    }

    handleEditClick () {

        this.setState( {
            isEditing: true
        } );

    }

    handleSaveClick ( event ) {

        event.preventDefault();
        const payload = {
            environment: this.state.selectedEnvironment,
            inventorySource: this.state.selectedInvSource.value,
            atpTransaction: this.state.selectedTransactionVal,
            suppress: this.state.selectedSuppressVal
        };

        this.props.increaseCounter();

        saveATPSetup( payload ).then( response => {

            if ( response.status === 201 ) {

                this.props.createSuccessMessage( `ATP Setup Updated Successfully for ${this.state.selectedInvSource.label}` );

            }
            this.refresh();
            this.props.decreaseCounter();

        } ).catch( () => {

            this.props.decreaseCounter();

        } );

    }

    handleCloseClick ( event ) {

        event.preventDefault();
        this.refresh();
        this.setState( {
            isEditing: false
        } );

    }

    getsuppressflagDropdown () {

        getSuppressSources()
            .then( response => {

                this.setState( {
                    atpSupressFlags: response
                } );
                this.props.decreaseCounter();

            } )
            .catch( () => {

                this.props.decreaseCounter();

            } );

    }

    removeSupress = ( options, str ) => options.filter( opt => opt.id !== str );

    loadTransactionsDropdown () {

        getTransactionSources().then( response => {

            this.setState( {
                atpTransactions: response
            } );
            this.props.decreaseCounter();

        } )
            .catch( () => {

                this.props.decreaseCounter();

            } );

    }

    refresh () {

        this.props.increaseCounter();
        getATPSetup( this.state.selectedEnvironment, this.state.selectedInvSource.value )
            .then( response => {

                const res = response;
                this.setState( {
                    results: res,
                    selectedTransactionVal: res.atpTransaction,
                    selectedSuppressVal: res.suppress,
                    isEditing: false
                } );

                this.props.decreaseCounter();

            } ).catch( () => {

                this.props.decreaseCounter();

            } );

    }

    render () {

        const {
            environments,
            inventorySources,
            selectedEnvironment,
            atpTransactions,
            selectedInvSource,
            selectedTransactionVal,
            isEditing,
            atpSupressFlags,
            results,
            selectedSuppressVal
        } = this.state;

        let atpSupressFlagsFiltered = atpSupressFlags;
        if ( results.suppress === '' ) atpSupressFlagsFiltered = this.removeSupress( atpSupressFlags, 'C' );
        else if ( results.suppress === 'C' ) atpSupressFlagsFiltered = this.removeSupress( atpSupressFlags, '' );
        else {

            atpSupressFlagsFiltered = this.removeSupress( atpSupressFlags, 'C' );
            atpSupressFlagsFiltered = this.removeSupress( atpSupressFlagsFiltered, '' );

        }

        let atpTransactionFiltered = atpTransactions;

        if ( results.atpTransaction === 'XDXCOF80' ) atpTransactionFiltered = this.removeSupress( atpTransactions, '' );
        else {

            atpTransactionFiltered = this.removeSupress( atpTransactions, 'XDXCOF80' );
            atpTransactionFiltered = this.removeSupress( atpTransactionFiltered, '' );

        }

        return (
            <section className="main-content">
                <BusyCounterLoadingIndicator busyCounter={this.props.busyCounter} />

                <main>
                    <section className="section-container">
                        <div className="atp-top-options atp-admin-top-options">
                            <div className="select-options">
                                <OptionsDropDown
                                    className="atp-admin-select"
                                    label="Environment"
                                    isPlaceholderTranslated={true}
                                    onChange={this.handleEnvironmentChange.bind( this )}
                                    optionDisplayAttributes={['value']}
                                    optionKey="id"
                                    options={environments}
                                    placeholder="Select Environment"
                                    selectedValue={selectedEnvironment}
                                />
                                {selectedEnvironment && (
                                    <LabeledReactSelect
                                        className="atp-admin-select"
                                        label="Inventory Sources"
                                        isPlaceholderTranslated={true}
                                        onChange={this.handleinvSrcChange.bind( this )}
                                        optionKey="id"
                                        optionDisplayAttributes={['label']}
                                        options={inventorySources}
                                        placeholder="Select InventorySource"
                                        selectedValue={selectedInvSource}
                                    />

                                )}
                                {selectedEnvironment && selectedInvSource && <span onClick={this.refresh.bind( this )}><i className="icon fa fa-refresh" /></span>}

                            </div>
                        </div>
                    </section>
                    {selectedEnvironment && selectedInvSource && (
                        <section className="section-container">
                            <div className="select-res">
                                {results && results.editable && !isEditing && (

                                    <span onClick={this.handleEditClick.bind( this )}>
                                        <i className="  fa fa-pencil-square-o icons" />
                                    </span>

                                )}
                                {results && isEditing && (

                                <>
                                    <span onClick={this.handleSaveClick.bind( this )}>
                                        <i className=" fa fas fa-save icons" />
                                    </span>
                                    <span onClick={this.handleCloseClick.bind( this )}>
                                        <i className="icons fa fal fa-times icons" />
                                    </span>
                                </>
                                )}
                            </div>

                            <div className="atp-result-options">
                                <div className="select-result-options">
                                    <LabeledInput
                                        className="atp-label-input"
                                        name="Description"
                                        isEditable={false}
                                        label="Inventory Source"
                                        maxLength={12}
                                        value={results.inventoryDescription}
                                    />
                                    <LabeledInput
                                        className="atp-label-input"
                                        name="ATP Flag"
                                        isEditable={false}
                                        label="ATP Flag"
                                        value={results.atpflag}
                                    />
                                    <OptionsDropDown
                                        className="atp-label-input"
                                        label="ATP Transaction"
                                        isPlaceholderTranslated={true}
                                        onChange={this.handleTransactionChange.bind( this )}
                                        optionDisplayAttributes={['value']}
                                        optionKey="id"
                                        options={atpTransactionFiltered}
                                        showPlaceholder={false}
                                        selectedValue={selectedTransactionVal}
                                        disabled={!isEditing}
                                    />
                                    <OptionsDropDown
                                        className="atp-label-input"
                                        label="Suppress ATP flag"
                                        isPlaceholderTranslated={true}
                                        onChange={this.handleSuppressChange.bind( this )}
                                        optionDisplayAttributes={['value']}
                                        optionKey="id"
                                        options={atpSupressFlagsFiltered}
                                        showPlaceholder={false}
                                        selectedValue={selectedSuppressVal}
                                        disabled={!isEditing}
                                    />
                                </div>
                            </div>

                        </section>
                    )}

                </main>
            </section>
        );

    }

}

const mapStateToProps = state => ( {
    busyCounter: showLoadingIndicator( state.application.busyCounter ),
    unit: state.application.unit,
    accessToken: state.oktaState.oktaState.accessToken
} );

ATPSetup.displayName = 'ATPSetup';
ATPSetup.propTypes = {
    busyCounter: PropTypes.bool.isRequired,
    increaseCounter: PropTypes.func.isRequired,
    decreaseCounter: PropTypes.func.isRequired,
    unit: PropTypes.object,
    location: PropTypes.object,
    createSuccessMessage: PropTypes.func.isRequired
};
const mapDispatchToProps = dispatch => ( {
    increaseCounter: () => dispatch( busyCounter.increaseBusyCounter() ),
    decreaseCounter: () => dispatch( busyCounter.decreaseBusyCounter() ),
    createSuccessMessage: message => dispatch( createSuccessMessage( message ) ),
    createErrorMessage: message => dispatch( createErrorMessage( message ) )
} );
export default connect(
    mapStateToProps, mapDispatchToProps
)( withRouter( ATPSetup ) );
